// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"419":"c1c8624264353d65","447":"bbe4b04465fc766d"}[chunkId] + ".js";
};